import { Box } from '@wix/design-system';
import { TrustBuilder } from '@wix/premium-purchase-platform/@components';
import React from 'react';
export const TrustBuilders = _ref => {
  let {
    align = 'left'
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    align: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(TrustBuilder.Root, null, /*#__PURE__*/React.createElement(TrustBuilder.Item.PaymentMethods, {
    align: align
  }), /*#__PURE__*/React.createElement(TrustBuilder.Item.MoneyBack, {
    align: align
  }), /*#__PURE__*/React.createElement(TrustBuilder.Item.Ssl, {
    align: align
  })));
};
//# sourceMappingURL=TrustBuilders.js.map